<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <div class="total_con">
      <el-form :inline="true">
        <el-form-item label="交易返佣总金额:"><p>{{ totalNum.total }}</p></el-form-item>
        <el-form-item label="直客交易总盈亏:"><p>{{ roundHalfUp(sumStat.totalCloseTrade) }}</p></el-form-item>
        <el-form-item label="直客总净入金:"><p>{{ roundHalfUp(sumStat.totalNetCashIn) }}</p></el-form-item>
        <el-form-item label="直客交易总手数:"><p>{{ roundHalfUp(sumStat.totalVolume) }}</p></el-form-item>
        <el-form-item label="总活跃交易人数:"><p>{{ sumStat.activeCustomers }}</p></el-form-item>
      </el-form>
    </div>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import UPDATE from '@/components/page/update'
import Url from '@/views/proxy/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil'
import slotLevel from '@/views/proxy/adAgent/components/slotLevel.vue'

export default {
  name: 'rebateLevel',
  components: {
    FORM,
    tablePage,
    UPDATE
  },
  data() {
    return {
      groupId: DateUtil.getParamKey(this.$route.params),
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '结算代理編碼', field: 'agentCode' },
          { title: '所属代理編碼', field: 'parentCode' },
          {
            title: '时间',
            field: 'time',
            type: 6,
            format: 'yyyy-MM-dd HH:mm:ss',
            startEndParam: ['startTime', 'endTime']
          },
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.rebateLevel + '?groupId=' + DateUtil.getParamKey(this.$route.params),
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: '结算代理编码', field: 'agentCode' },
          { title: '结算代理名称', field: 'agentName' },
          { title: '级别', field: 'level' },
          { title: '所属一级代理编码', field: 'parentCode' },
          { title: '所属一级代理名称', field: 'parentAgentName' },
          { title: '直客交易返佣', field: 'directRebateTotal' },
          { title: '其他代理分成返佣', field: 'otherRebateTotal' },
          {
            title: '开始时间', field: 'startTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '结束时间', field: 'endTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '总交易返佣（包含下级代理总分成）', field: 'rebateTotal' },
          { title: '直客交易总盈亏（预设显示当前交易月）', field: 'closeTradeTotal', render: (data, full) => {
              return this.roundHalfUp(data);
            } },
          { title: '直客总净入金（预设显示当前交易月）', field: 'netCashInTotal', render: (data, full) => {
              return this.roundHalfUp(data);
            }  },
          { title: '直客交易总手数（预设显示当前交易月）', field: 'volumeTotal', render: (data, full) => {
              return this.roundHalfUp(data);
            }  },
          { title: '活跃交易人数（预设显示当前交易月）', field: 'activeCustomerNumbers', render: (data, full) => {
              return data ? data.length : 0;
          }}
        ]
      },
      totalNum: {},
      sumStat: {}
    }
  },
  methods: {
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      data.groupId = this.groupId
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      }
      this.getTotalNum(data)
      this.getAgentRevenueSumStat(data)
    },
    getTotalNum(option) {
      this.$axios.get(Url.adAgent.rebateDetailTotal, { params: option }).then(res => {
        if (res.code == 0) {
          this.totalNum = res.result
        }
      })
    },
    getAgentRevenueSumStat(option) {
      this.$axios.get(Url.adAgent.agentRevenueSumStat, { params: option }).then(res => {
        if (res.code == 0) {
          this.sumStat = res.result
        }
      })
    },
    roundHalfUp(value) {
      return Number(Math.round(value + 'e' + 2) + 'e-' + 2);
    }
  },
  mounted() {
    this.getTotalNum({ groupId: this.groupId })
    this.getAgentRevenueSumStat()
  }
}
</script>

<style>
.customerList .total_con {
  width: 96%;
  margin: 0 auto;
}

.customerList .total_con .el-form-item {
  margin: 0 30px 0 0;
}

.customerList .total_con p {
  color: #ff5500;
  font-size: 16px;
  font-weight: bolder;
}
</style>
